import React from "react"

const InformationSection: React.FC = () => {
  return (
    <section className="w-full max-w-[1100px] mx-auto px-6 sm:px-8 py-12 sm:py-16">
      <h2 className="text-3xl sm:text-4xl font-bold text-primary text-center">
        Thực đơn
      </h2>
      <div className="mt-6 sm:mt-8 text-base sm:text-lg leading-relaxed text-primary space-y-4 text-justify max-w-[700px] mx-auto">
        <p>
          Hãy để Thiền Trúc đồng hành cùng bạn trong những bữa ăn an lành, nơi
          mỗi món chay là một niềm vui nhỏ, nuôi dưỡng cả thân lẫn tâm.
        </p>
        <p>
          Ở Thiền Trúc, một bữa ăn không chỉ là chuyện thưởng thức vị ngon, mà
          là khoảnh khắc lắng lại, chăm sóc thân – tâm – trí. Chúng tôi tin
          rằng, mỗi món chay là một câu chuyện nhỏ, kể về sự lành, sự an nhiên
          của đất trời, gửi đến người thưởng thức.
        </p>
        <p>
          Chúng tôi chọn lựa nguyên liệu như chọn người bạn đồng hành: tươi
          lành, hài hòa với nhịp điệu tự nhiên. Món ăn được nấu không chỉ bằng
          công thức, mà bằng sự chánh niệm và tình yêu với ẩm thực chay.
        </p>
        <p>
          Khi bạn dùng bữa cùng Thiền Trúc, đó là một cuộc trò chuyện thầm lặng
          với đất trời, một chút nắng, một chút gió, một chút an nhiên trong
          từng hương vị.
        </p>
      </div>
    </section>
  )
}

export default InformationSection
